export default function checkNotReportingYear(selected) {
    const date = new Date();
    const currentYear = date.getFullYear();
    return parseInt(selected) < parseInt(currentYear);
};